export default {
    storeConfig:[
      {
        'domain': 'demo.fancyecommerce.com',
        'lang_code' : 'zh',
        'currency_code' : 'EUR'
      }
    ]
}


// WEBPACK FOOTER //
// ./src/config/store.js